import { USER_ACTIONS, apologize } from './actions';
import schedulerApi from '../services/schedulerApi';

export function logInUser(user, retryCount = 0) {
    return function (dispatch) {
        return schedulerApi.login(user)
        .then(
            loggedInUser => dispatch(userLoggedIn(loggedInUser))
        )
        .catch(error => {
            console.error('Login error:', error.message);

            // Retry up to 3 times for network/transient errors
            if (retryCount < 3) {
                console.log(`Retrying login (attempt ${retryCount + 2}/4)...`);
                return new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)))
                    .then(() => dispatch(logInUser(user, retryCount + 1)));
            }

            // After retries, show error but don't force logout
            // User can manually retry by refreshing
            dispatch(apologize('Login failed: ' + error.message + '. Please refresh to try again.'));

            // Only logout if the error indicates user is not authorized
            // (e.g., no company found), not for network errors
            if (error.message && error.message.includes('Cannot find a company')) {
                return dispatch(logOutUser());
            }
        });
    };
}

function userLoggedIn(loggedInUser) {
    return {
        type: USER_ACTIONS.USER_LOGGED_IN,
        loggedInUser
    }
}

export function logOutUser() {
    return function (dispatch) {
        return schedulerApi.logout()
        .then(
            () => dispatch(userLoggedOut()),
            (error) => dispatch(apologize(error.message))
        )
    }
}

function userLoggedOut(loggedInUser) {
    return {
        type: USER_ACTIONS.USER_LOGGED_OUT
    }
}
